import React from 'react'
import request from 'utils/request'
import { connect } from 'react-redux'
import Validator from 'validatorjs'
import PropTypes from 'prop-types'

import BaseComponent from 'utils/BaseComponent'

import Input from 'components/Input'
import Button from 'components/Button'
import Select from 'components/Select'

import AddLocation from 'modals/AddLocation'

import { STATES_URL, CITIES_URL, USER_PROFILE_URL, CLIENT_DETAIL_URL } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'
import {  updateUserData,
          stateChanged,
          locationChanged,
          updateClientData } from 'scenes/ClientDetail/actions'


import './styles.scss'

export class EditClientModal extends BaseComponent {
  static validationRules = {
    first_name: 'string|required|min:2',
    last_name: 'string|required|min:2',
    email: 'required|email',
    confirm_email: 'required|same:email'
  }

  constructor(props) {
    super(props)
    const user = props.user
    const client = props.client
    this.state = {
      states: [],
      cities: [],
      buttonProps: {
        disabled: false
      },
      userData: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        confirm_email: user.email,
      },
      clientData: {
        phone_number: client.phone_number,
        rfc: client.rfc,
        gender: client.gender,
        zip_code: client.zip_code,
        city: client.city
      },
      errors: {}
    }
    this._bind( '_handleChange', '_validate', '_handleSubmit', '_fetchStates',
                '_fetchCities', '_showNewLocation', '_onLocationCreated', '_updateLocation')
  }

  componentDidMount() {
    this._fetchStates()
  }

  _fetchStates() {
    request(STATES_URL)
    .then((res) => {
      const states = res.states.map((state) => ({ value: state.id, label: state.name }))
      this.setState({ states })
    })
    .catch((err) => console.log(err))
  }

  _fetchCities(selectedOption) {
    const stateID = !!selectedOption ? selectedOption.value : null
    this.props.stateChanged(stateID, null)
    request(CITIES_URL(stateID))
      .then((res) => {
        const cities = res.cities.map((city) => ({ value: city.id, label: city.name }))
        this.setState({ cities })
      })
      .catch((err) => console.log(err))
  }

  _handleSubmit(e) {
    e.preventDefault()
    this.props.updateRequestStatus('progress', 'Cambio de datos en progreso')

    request(USER_PROFILE_URL(this.props.user.uuid), {
      method: 'PUT',
      body: { ...this.state.userData }
    })
    .then((res) => {
      this.props.updateRequestStatus(res.status, res.message)
      this.props.updateUserData(res.user)
      this.context.toggleModal(false)
    })
    .catch((err) => {
      const errors = !!err.fields ? {...err.fields} : {}
      this.setState({ errors })
      this.props.updateRequestStatus(err.status, err.message)
    })

    if(!!this.props.location.id) {
      this._updateLocation(this.props.location.id)
    }
  }

  _updateLocation(id) {

    request(CLIENT_DETAIL_URL(this.props.user.uuid), {
      method: 'PUT',
      body: {
        ...this.state.clientData,
        city: id
      }
    })
      .then((res) => {
        this.props.updateClientData(res.client)
      })
      .catch((err) => {console.log(err)})
  }

  _handleChange(e) {
    this.setState({
      userData: {
        ...this.state.userData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e)
  }

  _validate(e) {
    let userData = {
      ...this.state.userData,
      [e.target.name]: e.target.value
    }
    const validator = new Validator(userData, EditClientModal.validationRules)
    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  _onLocationCreated(state, city) {
    this._fetchCities(state.id, state.name)
  }

  _showNewLocation() {
    this.context.secondToggleModal(true,
      <AddLocation  user={this.props.user}
                    options={this.state.states}
                    onCreated={this._onLocationCreated}
                    isSecondModal={true}
                    state={this.props.state}
                    location={this.props.location}/>
    )
  }


  render() {
    const userData = this.state.userData
    return(
      <div id="EditClientModal" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Editar datos de cuenta</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
          <div className="field-title">
            <h2 className="bold-text">Datos de cuenta</h2>
          </div>
          <div className="modal-elements-container">
            <div className="modal-elements d-flex justify-content-between">
              <Input  id="first_name"
                      name="first_name"
                      errors={this.state.errors.first_name}
                      onChange={this._handleChange}
                      placeholder="Nombre"
                      value={userData.first_name}
                      autoFocus />
              <Input  id="last_name"
                      name="last_name"
                      errors={this.state.errors.last_name}
                      onChange={this._handleChange}
                      placeholder="Apellido"
                      value={userData.last_name} />
            </div>
            <div className="modal-elements message d-flex justify-content-between">
              <p className="message cl-achromatic-b-color">
                Este correo electrónico será usado por el cliente para iniciar
                sesión en la aplicación móvil. IMPORTANTE verificar que este dato sea correcto.
              </p>
            </div>
            <div className="modal-elements d-flex justify-content-between">
              <Input  id="email"
                      name="email"
                      type="email"
                      errors={this.state.errors.email}
                      onChange={this._handleChange}
                      placeholder="Correo"
                      value={userData.email} />
              <Input  id="confirm_email"
                      name="confirm_email"
                      type="email"
                      errors={this.state.errors.confirm_email}
                      onChange={this._handleChange}
                      placeholder="Confirmación de correo"
                      value={userData.confirm_email} />
            </div>
            <div className="field-title">
              <h2 className="bold-text">Ubicación</h2>
            </div>
            <div className="section-elements d-flex justify-content-between align-items-center location-data">
                <Select
                  options={this.state.states}
                  onChange={this._fetchCities}
                  placeholder="Estado *"
                  value={this.props.state.id}
                />
                <div className="location-select d-flex align-items-center justify-content-center">
                  <Select
                    options={this.state.cities}
                    onChange={this.props.locationChanged}
                    placeholder="Localidades *"
                    value={this.props.location.id}
                  />
                  <i onClick={this._showNewLocation} className="material-icons">add</i>
                </div>
              </div>
          </div>
          <div className="controls d-flex justify-content-end">
            <Button className="button"
                    size="small"
                    buttonType="primary"
                    {...this.state.buttonProps}>Actualizar datos de cuenta</Button>
          </div>
        </form>
      </div>
    )
  }
}


EditClientModal.contextTypes = {
  toggleModal: PropTypes.func.isRequired,
  secondToggleModal: PropTypes.func.isRequired
}


const mapStateToProps = (state) => {
  return {
    state: state.clientDetail.get('state').toObject(),
    location: state.clientDetail.get('location').toObject(),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    updateUserData: (detail) => dispatch(updateUserData(detail)),
    updateClientData: (detail) => dispatch(updateClientData(detail)),
    stateChanged: (id, name) => dispatch(stateChanged(id, name)),
    locationChanged: (location) => dispatch(locationChanged(location))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditClientModal)



// WEBPACK FOOTER //
// ./src/scenes/ClientDetail/components/EditClientModal/index.js